import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HardHat, Briefcase, Users, Wrench, FileText, GraduationCap, Dumbbell, PiggyBank, CalendarHeart, Baby, Sparkles } from "lucide-react";
import api, { gbp } from "@/lib/api";

const ICONS = { safety: HardHat, business: Briefcase, hr: Users, trades: Wrench, career: GraduationCap, fitness: Dumbbell, money: PiggyBank, planners: CalendarHeart, learning: Baby, creators: Sparkles };
const ACCENT = { safety: "#FFC107", business: "#0047AB", hr: "#7C3AED", trades: "#E63946", career: "#00875A", fitness: "#FF6B00", money: "#0E7490", planners: "#B45309", learning: "#DB2777", creators: "#4F46E5" };

export const DocsSpotlight = () => {
  const [ranges, setRanges] = useState([]);
  useEffect(() => { api.get("/workplace-documents").then((r) => setRanges(r.data.ranges || [])).catch(() => {}); }, []);
  if (!ranges.length) return null;
  const total = ranges.reduce((s, r) => s + r.count, 0);
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-20" data-testid="home-docs-spotlight">
      <div className="border border-[#FFC107]/30 bg-[#FFC107]/[0.05] p-8 md:p-10" data-testid="home-safety-banner">
        <div className="flex flex-col md:flex-row md:items-end gap-6 mb-8">
          <div className="flex-1">
            <span className="label-caps text-[#FFC107] flex items-center gap-2"><FileText className="w-4 h-4" />MRQK Documents & Templates · For UK work, money and life</span>
            <h2 className="font-heading text-2xl md:text-3xl tracking-tight font-medium mt-1 mb-2 text-white">Documents, spreadsheets and planners, ready today</h2>
            <p className="text-neutral-400 max-w-2xl">{total} plain-English packs across {ranges.length} ranges — risk assessments, HR policies, contractor paperwork and career packs, plus budget, side-hustle and landlord spreadsheets in pounds, ADHD and wellbeing planners, kids worksheets and creator kits. Instant download.</p>
          </div>
          <Link to="/workplace-documents" data-testid="home-safety-cta" className="bg-[#FFC107] text-black px-6 py-3 font-medium hover:bg-white transition-colors flex items-center gap-2 whitespace-nowrap self-start md:self-auto">Browse all documents <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
          {ranges.map((r) => {
            const Icon = ICONS[r.key] || FileText;
            return (
              <Link key={r.key} to={`/workplace-documents?cat=${r.key}`} data-testid={`home-docs-range-${r.key}`}
                className="border border-white/10 bg-white/[0.03] p-4 hover:border-white/40 hover:-translate-y-0.5 transition-all duration-200 group">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center shrink-0" style={{ background: ACCENT[r.key] }}><Icon className="w-4 h-4 text-white" strokeWidth={1.75} /></span>
                  <h3 className="text-white text-sm font-medium leading-tight">{r.label}</h3>
                </div>
                <p className="text-xs text-neutral-500">{r.count} docs · from {gbp(r.from_price)}{r.bundle_price ? ` · bundle ${gbp(r.bundle_price)}` : ""}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
